// extracted by mini-css-extract-plugin
export default {"inputWrapper":"ui-text-field_inputWrapper__BOuGX"};